const setImageSizeString = (size: string) => {
  switch (size) {
    case 'xs':
      return '-Small';
    case 'sm':
      return '-Medium';
    case 'md':
      return '-Medium';
    case 'lg':
      return '-Large';
    case 'xl':
      return '-Large';
    case 'xxl':
      return '-Large';
    default:
      return '-Large';
  }
};

export { setImageSizeString };
